const LOGO = "/logo-blue.png";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0B203B] text-white pt-16 pb-8" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <img src={LOGO} alt="Legacy Security Life" className="h-14 w-14 rounded-md object-cover" />
              <div>
                <p className="font-serif text-xl">Legacy Security Life</p>
                <p className="text-[11px] tracking-[0.2em] uppercase text-[#E8C97A]">Final Expense Solutions</p>
              </div>
            </div>
            <p className="mt-5 text-white/70 max-w-md leading-relaxed">
              Helping seniors and their families protect what matters most — with affordable, guaranteed-acceptance final expense
              life insurance, backed by A-rated carriers.
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#E8C97A] font-semibold">Explore</p>
            <ul className="mt-4 space-y-2 text-white/80">
              <li><a href="#about" className="hover:text-[#E8C97A]" data-testid="footer-link-about">About</a></li>
              <li><a href="#plans" className="hover:text-[#E8C97A]" data-testid="footer-link-plans">Coverage Plans</a></li>
              <li><a href="#benefits" className="hover:text-[#E8C97A]" data-testid="footer-link-benefits">Benefits</a></li>
              <li><a href="#faq" className="hover:text-[#E8C97A]" data-testid="footer-link-faq">FAQ</a></li>
              <li><a href="#contact" className="hover:text-[#E8C97A]" data-testid="footer-link-contact">Contact</a></li>
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#E8C97A] font-semibold">Contact</p>
            <ul className="mt-4 space-y-2 text-white/80">
              <li><a href="tel:8333095433" data-testid="footer-phone">833-309-LIFE</a></li>
              <li><a href="mailto:sales@legacysecuritylife.com" className="break-all" data-testid="footer-email">sales@legacysecuritylife.com</a></li>
              <li>401 E Jackson Street, Suite 3300</li>
              <li>Tampa, FL 33602</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/60">
          <p>© {year} Legacy Security Life. All rights reserved.</p>
          <p>
            Insurance products are offered through licensed agents. Coverage, premiums, and acceptance vary by carrier and state.
            Not available in all states.
          </p>
        </div>
      </div>
    </footer>
  );
}
